import React from 'react';
// import sections
import HomeHero from '../components/sections/HomeHero';
import FeaturesTiles from '../components/sections/FeaturesTiles';
import FeaturesSplit from '../components/sections/FeaturesSplit';
import Testimonial from '../components/sections/Testimonial';
import Cta from '../components/sections/Cta';
import ServicesMVSplit from '../components/sections/ServicesMVSplit';
import CompanyGoals from '../components/sections/CompanyGoals';
import RssFeed from '../components/sections/RssFeed';
import HomeMVSplit from '../components/sections/HomeMVSpilit';
import HomeMVTiles from '../components/sections/HomeMVTiles';
import WhyChooseUs from '../components/sections/WhyChooseUs';
import EnergyEfficiencyMeasuresHero from '../components/sections/EnergyEfficiencyMeasuresHero'
import Insulation from '../components/sections/Insulation';

const EnergyEfficiencyMeasures = () => {

  return (
    <>
      <EnergyEfficiencyMeasuresHero className="illustration-section-01" />
      <Insulation />
      {/* <HomeMVTiles />
      <CompanyGoals />
      <WhyChooseUs /> */}
      {/* <HomeMVSplit /> */}
      {/* <ServicesMVSplit invertMobile topDivider imageFill className="illustration-section-02" /> */}
      {/* <RssFeed /> */}
      {/* <FeaturesTiles /> */}
      {/* <Testimonial topDivider /> */}
      {/* <Cta split /> */}
    </>
  );
}

export default EnergyEfficiencyMeasures;